class CurrencyAttributesManagerElement extends HTMLElement {
  connectedCallback() {
    this.currencyCode = this.dataset.cartCurrencyCode;
    this.cartCount = this.dataset.cartCount;

    if (typeof subscribe !== 'undefined') {
      subscribe('cart:added', this.handleCartEvent.bind(this));
      subscribe('cart:updated', this.handleCartEvent.bind(this));
    }

    setTimeout(() => {
      this.updateCartAttributes();
    }, 300);
  }

  handleCartEvent() {
    this.updateCartAttributes();
  }

  updateCartAttributes() {
    let rate = Shopify.currency.rate;
    if (rate === null) return;
    if (this.currencyCode !== 'EUR') {
      rate = rate * 0.98;
    }

    rate = rate.toString();

    fetch(`${window.routes.cart_update_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          'Invoice Currency': this.currencyCode,
          'Invoice Currency Rate': `${rate}`,
        },
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
      });
  }
}

customElements.define('currency-attributes-manager', CurrencyAttributesManagerElement);
